<div class="m-0 p-1" style="min-height: 260px; max-height: 260px;">
  <div *ngIf="!readonly">
    <button
      mat-raised-button
      color="primary"
      class="mt-1 mb-2"
      (click)="addContato()"
    >
      Adicionar Contato
    </button>
  </div>
  <mat-divider></mat-divider>
  <ng-template #notLenght>
    <div
      style="height: 200px; display: flex; justify-content: center; align-items: center;"
    >
      <div
        class="flex justify-content-center align-items-center flex-column"
        style="color: #999;"
      >
        <i class="mdi mdi-phone-off-outline icon-format-empty-list"></i>
        <p style="font-size: 16px; text-align: center;">
          Nenhum contato cadastrado
        </p>
      </div>
    </div>
  </ng-template>
  <ng-template #list>
    <mat-list
      class="row mt-3 justify-content-center"
      [ngClass]="{ 'mat-mdc-list-flex': true }"
    >
      <mat-list-item
        class="col-md-5 card mat-elevation-z5 cursor-pointer mr-2"
        pTooltip="Editar contato"
        (click)="editarContato(contato, i)"
        *ngFor="let contato of entityTemp.contatos; let i = index"
      >
        <div
          class="flex align-items-center justify-content-between width-100 p-2"
        >
          <div class="flex flex-column">
            <div matLine class="font-light mb-2">
              <i
                matListIcon
                class="pi pi-fw pi-address-book text-primary fs-small"
              ></i>
              <span matLine class="fs-normal ml-2">{{
                contato.contato.length > 15
                  ? contato.contato.substring(0, 15) + "..."
                  : contato.contato
              }}</span>
            </div>
            <span class="font-bold" matLine>
              {{
                formatarTags(
                  contato.tag.length > 15
                    ? contato.tag.substring(0, 15)
                    : contato.tag
                )
              }}
            </span>
          </div>
          <button
            [disabled]="readonly"
            (click)="removerContato($event, contato)"
            type="button"
            id="button-remove-item-{{ i }}"
            mat-icon-button
            pTooltip="Remover contato"
          >
            <mat-icon class="text-red-500">delete</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </ng-template>
  <ng-container
    [ngTemplateOutlet]="entity.contatos.length > 0 ? list : notLenght"
  ></ng-container>
</div>
